import { Pipe, PipeTransform } from '@angular/core';

import { ADPResourceService as ResourceService } from 'digital-core';

@Pipe({
  name: 'localCurrency'
})
export class LocalCurrencyPipe implements PipeTransform {
  constructor(private resourcesService: ResourceService) {}
  transform(value: any, args?: any): any {
    if (!value) {
      return "";
    }

    let options: any = {};
    options.style = "currency";
    options.currency = this.resourcesService.getLocalizationSettings().ClientLocalCurrency

    let result = Number(value).toLocaleString(
      this.resourcesService.getLocalizationSettings().ClientLocalLanguage,
      options
    );
    // console.log(result);
    return result;
  }
}
